import { useEffect } from "react";

import i18n from "../../i18n";
import { useCookies } from "react-cookie";
import { getCookie, getDomain, getShortLang } from "../../utils/utils";

export const ENUM_LANG_LISTENER = {
  auto: "auto",
};

export const languages = [
  { title: "English", flag: "us", code: "en", country: "US", lang: "en_US" },
  { title: "Русский", flag: "ru", code: "ru", country: "RU", lang: "ru_RU" },
  { title: "Español", flag: "es", code: "es", country: "ES", lang: "es_ES" },
];

export default function useLanguage() {
  const shortLang = getShortLang();
  const keepDay = getCookie("remember_me") ? 365 : 1;

  const cookieSetting = {
    path: "/",
    domain: `.${getDomain()}`,
    sameSite: "None",
    secure: true,
    expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * keepDay),
  };
  const chosenLang = languages.find((el) => el.code === shortLang)?.lang;

  const [{ language: cookieLang }, setCookieLang] = useCookies(["language"]);

  useEffect(() => {
    // если в куке есть, то больше не заполняем
    if (cookieLang && cookieLang !== "undefined") return;
    if (!chosenLang) return;

    setCookieLang("language", chosenLang, cookieSetting);
  }, [cookieLang, chosenLang]);

  useEffect(() => {
    const code = cookieLang?.split?.("_")?.[0];
    if (!code) return;
    i18n.changeLanguage(code);
  }, [cookieLang]);

  return [
    cookieLang,
    (lang) => {
      console.log("new lang", lang);
      setCookieLang("language", lang, cookieSetting);
    },
  ];
}
